/* Collett v3 — productkaart Final 2.0.

   Twee dingen:

   1. Het matenpaneel. Op desktop klapt het open bij hover; op de telefoon
      opent de knop "Maat kiezen" op de foto het als bodemsheet. Een tik op de
      foto of de naam gaat altijd meteen naar het product.
      Er staat er hooguit één open. Esc, een klik ernaast, en op desktop ook de
      muis van de kaart af, sluiten hem.
   2. Een maat aanklikken legt dat paar meteen in het mandje. Daarna gaat er een
      collett:toegevoegd-gebeurtenis uit; collett-v3-lagen.js haalt het mandje
      op, laat het paar naar het mandje vliegen en toont de balk. Die drie
      dingen staan daar al voor de productpagina, dus die doen we niet nog eens.

   Alles is gedelegeerd vanaf document, zodat kaarten die later binnenkomen
   (filteren, doorladen, de Silhouetten-sectie) het ook doen. */
(() => {
  const KAART = '[data-pc-kaart]';
  const WACHT_GELUKT = 2200;
  const C = window.COLLETT || {};

  let open = null;

  const kanHoveren = () => window.matchMedia && window.matchMedia('(hover: hover)').matches;
  const isMobiel = () => window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

  /* ---------------- paneel openen en sluiten ---------------- */

  const zetTik = (kaart, isOpen) => {
    const tik = kaart.querySelector('[data-pc-tik]');
    if (!tik) return;
    const tekst = isOpen ? tik.dataset.pcTikOpen : tik.dataset.pcTikDicht;
    if (tekst) tik.textContent = tekst;
  };

  const sluit = () => {
    if (!open) return;
    const kaart = open;
    open = null;
    kaart.removeAttribute('data-pc-open');
    kaart.querySelectorAll('[data-pc-link][aria-expanded]').forEach((l) => {
      l.setAttribute('aria-expanded', 'false');
    });
    zetTik(kaart, false);
  };

  const openen = (kaart) => {
    if (open === kaart) return;
    sluit();
    open = kaart;
    kaart.setAttribute('data-pc-open', '');
    if (isMobiel()) {
      /* Het paneel is hier een bodemsheet met position:fixed. Een transform op
         de kaart — die collett-v3.js tijdens het filteren even zet — zou die
         fixed-positie aan de kaart ophangen in plaats van aan het scherm. */
      kaart.style.transform = '';
    }
    kaart.querySelectorAll('[data-pc-link][aria-expanded]').forEach((l) => {
      l.setAttribute('aria-expanded', 'true');
    });
    zetTik(kaart, true);
  };

  /* ---------------- in het mandje ---------------- */

  const fout = (kaart, melding) => {
    const vlak = kaart.querySelector('.pc-paneel__vlak');
    if (!vlak) return;
    const bestaand = vlak.querySelector('.pc-paneel__fout');
    if (bestaand) bestaand.remove();
    const el = document.createElement('p');
    el.className = 'pc-paneel__fout';
    el.setAttribute('role', 'alert');
    el.textContent = melding || 'Niet gelukt — probeer de productpagina.';
    vlak.prepend(el);
    setTimeout(() => el.remove(), 4000);
  };

  const gelukt = (knop) => {
    const tekst = knop.querySelector('[data-pc-maat-tekst]');
    if (!tekst) return;
    if (!knop.dataset.pcOrigineel) knop.dataset.pcOrigineel = tekst.textContent;
    knop.setAttribute('data-pc-gelukt', '');
    tekst.textContent = '✓ ' + knop.dataset.pcOrigineel;
    clearTimeout(knop._pcTimer);
    knop._pcTimer = setTimeout(() => {
      knop.removeAttribute('data-pc-gelukt');
      tekst.textContent = knop.dataset.pcOrigineel;
    }, WACHT_GELUKT);
  };

  const inHetMandje = async (knop) => {
    const kaart = knop.closest(KAART);
    const variant = knop.dataset.pcVariant;
    if (!kaart || !variant || knop.getAttribute('aria-busy') === 'true') return;
    if (!C.routes || !C.routes.toevoegen) return;

    knop.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(C.routes.toevoegen, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
      });
      if (!r.ok) {
        let melding = '';
        try {
          const data = await r.json();
          melding = data.description || data.message || '';
        } catch (e) {
          /* geen JSON terug; dan blijft de standaardtekst staan */
        }
        fout(kaart, melding);
        return;
      }
      gelukt(knop);
      /* Mandje ophalen, laten vliegen en de balk tonen doet collett-v3-lagen.js. */
      document.dispatchEvent(new CustomEvent('collett:toegevoegd', { detail: { bron: knop } }));
      /* Op mobiel staat de sheet over de onderkant van het scherm, en daar komt
         de bevestigingsbalk vandaan. Even de maat groen laten zien en dan dicht,
         anders ziet niemand dat het gelukt is. */
      if (isMobiel()) setTimeout(sluit, 650);
    } catch (err) {
      fout(kaart, '');
    } finally {
      knop.removeAttribute('aria-busy');
    }
  };

  /* ---------------- kleurenrij ---------------- */

  const kleuren = (kaart) => {
    if (kaart._pcKleuren) return kaart._pcKleuren;
    try {
      kaart._pcKleuren = JSON.parse(kaart.dataset.pcKleuren || '[]');
    } catch (e) {
      kaart._pcKleuren = [];
    }
    return kaart._pcKleuren;
  };

  const zetTekst = (kaart, kies, waarde) => {
    const el = kaart.querySelector(kies);
    if (el) el.textContent = waarde || '';
  };

  const kiesKleur = (knop) => {
    const kaart = knop.closest(KAART);
    const rij = knop.closest('.pc-kleuren');
    if (!kaart || !rij) return;
    const index = Number(knop.dataset.pcKleur);
    const kleur = kleuren(kaart)[index];
    if (!kleur || knop.getAttribute('aria-pressed') === 'true') return;

    sluit();
    rij.querySelectorAll('[data-pc-kleur]').forEach((k) => {
      k.setAttribute('aria-pressed', String(Number(k.dataset.pcKleur) === index));
    });

    /* Eén bron in plaats van een srcset: een srcset per kleur meesturen zou de
       kaart met tientallen URL's opzadelen, en op de breedste kolom is de kaart
       ruim 300px, dus 900px is ook op een scherm met dubbele pixeldichtheid
       ruim genoeg. */
    const een = kaart.querySelector('.pc-kaart__img--een');
    const twee = kaart.querySelector('.pc-kaart__img--twee');
    if (een && kleur.fotos && kleur.fotos[0]) {
      een.removeAttribute('srcset');
      een.src = kleur.fotos[0];
      een.alt = kleur.titel || '';
    }
    if (twee) {
      if (kleur.fotos && kleur.fotos[1]) {
        twee.removeAttribute('srcset');
        twee.src = kleur.fotos[1];
        twee.hidden = false;
      } else {
        twee.hidden = true;
      }
    }

    /* Staande foto's (kleding, accessoires) krijgen het vierkante kader. */
    const foto = kaart.querySelector('.pc-kaart__foto');
    if (foto) foto.classList.toggle('pc-kaart__foto--staand', !!kleur.staand);

    zetTekst(kaart, '[data-pc-titel]', kleur.titel);
    zetTekst(kaart, '[data-pc-merk]', kleur.merk);
    zetTekst(kaart, '[data-pc-nu]', kleur.prijs);
    /* De kop en de link van de bodemsheet horen bij dezelfde kleur. */
    zetTekst(kaart, '[data-pc-paneel-naam]', kleur.titel);
    zetTekst(kaart, '[data-pc-paneel-prijs]', kleur.prijs);
    const paneelPrijs = kaart.querySelector('[data-pc-paneel-prijs]');
    if (paneelPrijs) paneelPrijs.classList.toggle('pc-paneel__prijs--sale', !!kleur.was);
    const paneelLink = kaart.querySelector('[data-pc-paneel-link]');
    if (paneelLink && kleur.url) paneelLink.href = kleur.url;

    const was = kaart.querySelector('[data-pc-was]');
    if (was) {
      was.hidden = !kleur.was;
      if (kleur.was) was.textContent = kleur.was;
    }

    kaart.querySelectorAll('[data-pc-link]').forEach((l) => {
      if (kleur.url) l.href = kleur.url;
      if (l.hasAttribute('aria-label')) {
        l.setAttribute('aria-label', ((kleur.merk || '') + ' ' + (kleur.titel || '')).trim());
      }
    });

    /* Het Sale-kaartje opnieuw opbouwen. De opmaak staat in de CSS; hier staat
       alleen of er een kaartje is en wat erop staat. */
    const oud = kaart.querySelector('.pc-tag');
    if (oud) oud.remove();
    if (kleur.korting) {
      const tag = document.createElement('span');
      tag.className = 'pc-tag pc-tag--sale';
      const draad = document.createElement('span');
      draad.className = 'pc-tag__draad';
      draad.setAttribute('aria-hidden', 'true');
      const vlak = document.createElement('span');
      vlak.className = 'pc-tag__kaart';
      const gat = document.createElement('span');
      gat.className = 'pc-tag__gat';
      gat.setAttribute('aria-hidden', 'true');
      const klein = document.createElement('span');
      klein.className = 'pc-tag__klein';
      klein.textContent = 'Sale';
      const groot = document.createElement('span');
      groot.className = 'pc-tag__groot';
      groot.textContent = '−€' + kleur.korting;
      vlak.append(gat, klein, groot);
      tag.append(draad, vlak);
      if (foto) foto.append(tag);
    }

    /* Het oude labeltje linksboven hoort ook bij de kleur. */
    const label = kaart.querySelector('.kaart__label');
    if (label) label.remove();
    if (kleur.label) {
      const l = document.createElement('span');
      l.className = 'kaart__label' + (kleur.labelSoort === 'schaars' ? ' kaart__label--schaars' : '');
      l.textContent = kleur.label;
      if (foto) foto.append(l);
    }

    const raster = kaart.querySelector('[data-pc-maten]');
    if (raster) {
      raster.textContent = '';
      (kleur.maten || []).forEach((m) => {
        const b = document.createElement('button');
        b.className = 'pc-maat';
        b.type = 'button';
        b.setAttribute('data-pc-maat', '');
        b.dataset.pcVariant = String(m.id);
        b.setAttribute('aria-label', 'Maat ' + (m.label || '') + (m.prijs ? ', ' + m.prijs : '') + ', direct in je mandje');
        const t = document.createElement('span');
        t.setAttribute('data-pc-maat-tekst', '');
        t.textContent = m.kort || '';
        b.append(t);
        /* Zelfde als in v3-kaart: verschilt de prijs per maat, dan op de knop. */
        if (m.prijs) {
          const p = document.createElement('small');
          p.className = 'pc-maat__prijs';
          p.textContent = m.prijs;
          b.append(p);
        }
        raster.append(b);
      });
    }
  };

  /* ---------------- bodemsheet wegvegen ----------------
     Op mobiel is het matenpaneel een bodemsheet, en die hoort je naar beneden
     weg te kunnen vegen (Wessel via Jarno, 23-10-2026: "kan maten niet
     wegswipen"). De maten zelf veeg je zijwaarts door, dus hier alleen
     reageren op een beweging die duidelijk naar beneden gaat; begint de veeg
     ín het matenraster, dan is het bladeren en laten we hem met rust. */
  let sleepY = null;
  let sleepVlak = null;

  const sleepEinde = (gesloten) => {
    if (sleepVlak) {
      sleepVlak.style.transition = '';
      sleepVlak.style.transform = '';
    }
    sleepY = null;
    sleepVlak = null;
    if (gesloten) sluit();
  };

  document.addEventListener('touchstart', (e) => {
    if (!isMobiel() || !open || e.touches.length !== 1) return;
    const vlak = e.target.closest('.pc-paneel__vlak');
    if (!vlak || e.target.closest('[data-pc-maten]')) return;
    sleepVlak = vlak;
    sleepY = e.touches[0].clientY;
    vlak.style.transition = 'none';
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (sleepY === null || !sleepVlak) return;
    const dy = e.touches[0].clientY - sleepY;
    /* Alleen naar beneden meegeven; omhoog trekken doet niets. */
    sleepVlak.style.transform = dy > 0 ? `translateY(${dy}px)` : '';
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    if (sleepY === null) return;
    const eind = e.changedTouches && e.changedTouches[0];
    const dy = eind ? eind.clientY - sleepY : 0;
    /* 60px is ver genoeg om bedoeld te zijn en kort genoeg om licht te voelen. */
    sleepEinde(dy > 60);
  });

  document.addEventListener('touchcancel', () => {
    if (sleepY !== null) sleepEinde(false);
  });

  /* ---------------- luisteraars ---------------- */

  document.addEventListener('click', (e) => {
    /* Het doek achter de bodemsheet zit in de kaart, dus de klik-ernaast-regel
       onderaan vangt hem niet. */
    if (e.target.closest('[data-pc-sluit]')) {
      e.preventDefault();
      sluit();
      return;
    }

    const maat = e.target.closest('[data-pc-maat]');
    if (maat) {
      e.preventDefault();
      e.stopPropagation();
      inHetMandje(maat);
      return;
    }

    const kleur = e.target.closest('[data-pc-kleur]');
    if (kleur) {
      e.preventDefault();
      kiesKleur(kleur);
      return;
    }

    /* Een tik op de foto of de naam gaat gewoon naar het product, ook op de
       telefoon. Eerst opende die eerste tik de maten en ging pas de tweede naar
       het product; dat verwacht geen klant (Jarno, 25-10-2026). */
    if (e.target.closest('[data-pc-link]')) return;

    if (!e.target.closest(KAART)) sluit();
  });

  /* Op de telefoon opent "Maat kiezen" de bodemsheet van de kaart zelf, niet
     het zijpaneel van collett-v3-lagen.js: in de sheet staan de maten meteen
     in beeld en is één tik genoeg. In de capture-fase en met stopPropagation,
     zodat de klik niet ook nog bij de luisteraar van dat zijpaneel aankomt.
     Op desktop blijft de knop het zijpaneel openen. */
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('.pc-kaart__maatknop');
    if (!knop || !isMobiel()) return;
    const kaart = knop.closest(KAART);
    if (!kaart || !kaart.querySelector('[data-pc-paneel]')) return;
    e.preventDefault();
    e.stopPropagation();
    if (open === kaart) {
      sluit();
      return;
    }
    openen(kaart);
    if (e.detail > 0 && typeof knop.blur === 'function') knop.blur();
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !open) return;
    const terug = open.querySelector('[data-pc-link]');
    sluit();
    if (terug) terug.focus();
  });

  /* mouseleave bubbelt niet, dus mouseout met een blik op waar de muis heen
     gaat. Alleen op apparaten die echt hoveren; op een telefoon zou een tik het
     paneel anders meteen weer dichtdoen. */
  document.addEventListener('mouseout', (e) => {
    if (!open || !kanHoveren()) return;
    if (!open.contains(e.target)) return;
    if (e.relatedTarget && open.contains(e.relatedTarget)) return;
    sluit();
  });

  /* ---------------- tabbladen van de Silhouetten-sectie ---------------- */

  /* Eigen afhandeling en niet die van collett-v3.js: die pakt met $('.tabs') en
     $('[id^="raster-"]') het eerste element op de pagina, dus met v3-picks
     erbij zouden de twee secties elkaars tabbladen overnemen. Dit werkt per
     sectie en voor zoveel secties als er staan. */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-silh-tab]');
    if (!tab) return;
    const tabs = tab.closest('.silh__tabs');
    const sectie = tab.closest('.silh');
    if (!tabs || !sectie) return;
    const soort = tab.dataset.silhTab;

    sluit();
    tabs.querySelectorAll('[data-silh-tab]').forEach((t) => {
      const aan = t === tab;
      t.setAttribute('aria-selected', String(aan));
      t.tabIndex = aan ? 0 : -1;
    });
    sectie.querySelectorAll('[data-silh-groep]').forEach((vak) => {
      vak.hidden = vak.dataset.silhGroep !== soort;
    });
    const raster = sectie.querySelector('[data-silh-raster]');
    if (raster) raster.setAttribute('aria-labelledby', tab.id);
  });

  /* Op desktop wisselt de kleur al bij aanwijzen, zoals in het ontwerp. */
  document.addEventListener('mouseover', (e) => {
    if (!kanHoveren()) return;
    const kleur = e.target.closest('[data-pc-kleur]');
    if (kleur) kiesKleur(kleur);
  });

  document.addEventListener('focusin', (e) => {
    const kleur = e.target.closest('[data-pc-kleur]');
    if (kleur) kiesKleur(kleur);
  });
})();
